import {Component, forwardRef, Input, Optional} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbinputConfig,NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-froala',
  template: require('./nbinput-froala.component.html'),
  styles: [require('./nbinput-froala.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputFroalaComponent),
      multi: true
    }
  ]
})

export class NbinputFroalaComponent implements ControlValueAccessor {
  public FieldType = NbFieldType;
  @Input()
  public token = '';
  public host = '';
  public uploadHost = '';
  public options = {
    placeholderText: '点击这里开始输入',
    imageUploadURL: this.uploadHost,
    imageUploadParams: {token:this.token},
    language: 'zh_cn',
    events : {
      'froalaEditor.image.uploaded' : (e, editor, response) => {
        try{
          let resp = JSON.parse(response);
          let url = resp&&resp.data?resp.data.url:'';
          editor.image.insert(this.host+url, false, null, editor.image.get(), response);
        }
        catch (f){
          console.warn("文件上传失败：",f)
        }
        return false;
      }
    }
  };

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }
  @Input()
  public data = "";
  @Input()
  public disabled;

  @Input()
  public placeholder;

  @Input()
  public type: NbFieldType = NbFieldType.Html;
  @Input()
  public readonly = false;

  registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }
  writeValue(obj): void {
    if (obj){
      this.data = obj;
    }
  }
  onChange(e){
    this.onChangeCallback(e);
  }
  constructor(
    @Optional() private config: NbinputConfig,
  ){
    this.host = config.downloadAPI;
    this.uploadHost = config.uploadAPI;
  }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-froala.component.ts